import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=3da06f1f&scoped=true"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailsDrawer.vue?vue&type=style&index=0&id=3da06f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da06f1f",
  null
  
)

export default component.exports